import { useState, useEffect } from "react";
import { useParams, useLocation, NavLink } from "react-router-dom";
import {
  FaUserPlus,
  FaUsers,
  FaTasks,
  FaChartLine,
  FaComments,
  FaFileUpload,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

export default function InternSidebar({ isSidebarOpen, setIsSidebarOpen }) {
  const { uid: paramUid } = useParams();
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Get uid from params or localStorage as fallback
  const uid = paramUid || localStorage.getItem('adminId');

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Debug logging
  useEffect(() => {
    console.log('  bug:', {
      paramUid,
      localStorageAdminId: localStorage.getItem('adminId'),
      finalUid: uid,
      currentPath: location.pathname
    });
  }, [paramUid, uid, location.pathname]);

  const activeStyle = {
    background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
    boxShadow: "0 4px 15px rgba(99, 102, 241, 0.4)",
    color: "white",
    transform: "translateX(5px)",
    borderLeft: "4px solid #fff",
  };

  const defaultStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
    color: "rgba(255, 255, 255, 0.85)",
    transition: "all 0.3s ease",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.18)",
      transform: "translateX(3px)",
      color: "white",
    }
  };

  const links = [
    {
      to: `intern-onboarding`,
      label: "Intern Onboarding",
      icon: <FaUserPlus className="me-2" />,
    },
    {
      to: `task-board`,
      label: "Task Board",
      icon: <FaTasks className="me-2" />,
    },
    {
      to: `daily-logs`,
      label: "Daily Logs",
      icon: <FaChartLine className="me-2" />,
    },
    {
      to: `feedback-management`,
      label: "Feedback",
      icon: <FaComments className="me-2" />,
    },
    {
      to: `file-management`,
      label: "File Management",
      icon: <FaFileUpload className="me-2" />,
    },
  ];

  return (
    <>
      {(isSidebarOpen || windowWidth >= 768) && (
        <div
          className="d-flex flex-column p-3 text-white position-fixed"
          style={{
            background: "linear-gradient(180deg, #1e1b4b 0%, #312e81 50%, #3730a3 100%)",
            width: "250px",
            height: "100vh",
            top: 0,
            left: 0,
            zIndex: 2000,
            overflowY: "auto",
            transition: "transform 0.3s ease-in-out",
            transform:
              isSidebarOpen || windowWidth >= 768
                ? "translateX(0)"
                : "translateX(-100%)",
            boxShadow: "2px 0 10px rgba(0,0,0,0.1)"
          }}
        >
          {windowWidth < 768 && (
            <div className="d-flex justify-content-end mb-2">
              <button
                className="btn btn-light btn-sm"
                onClick={() => setIsSidebarOpen(false)}
              >
                <FaTimes style={{ color: "#a70a4a" }} />
              </button>
            </div>
          )}

          <div className="text-center mb-4">
            <img
              src="/images/LOGO.png"
              alt="Logo"
              className="rounded"
              style={{ width: "120px" }}
            />
            <h6 className="mt-2">Intern Management</h6>
          </div>

          <ul className="nav flex-column gap-2">
            {links.map(({ to, label, icon }) => (
              <li className="nav-item" key={label}>
                <NavLink
                  to={to}
                  end
                  className="sidebar-button nav-link px-3 py-2 rounded"
                  style={({ isActive }) => (isActive ? activeStyle : defaultStyle)}
                  onClick={() => {
                    if (windowWidth < 768) setIsSidebarOpen(false);
                  }}
                >
                  {icon} {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
